import * as React from 'react';
import {WithStyles, withStyles} from '@material-ui/core';
import LocationIcon from '@material-ui/icons/PlaceRounded';
import TranslateNew from '@translate/TranslateNew';
import { IHandoverData } from './calendar.types';
import { DayVisitChangeStyle } from './DayVisitChange.style';

const tn:TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof DayVisitChangeStyle> {
  boxClassName:string;
  parent:string;
  from:IHandoverData;
  to:IHandoverData;
  oldFrom?:IHandoverData;
  oldTo?:IHandoverData;
  removed?:boolean;
  // shown instead of a time when the handover is at school
  schoolName:string;
}

const DayVisitChange = (props:IProps):JSX.Element => {
  const {classes} = props;

  const renderHandover = (handover:IHandoverData, className:string):JSX.Element => (
    <div className={className}>
      <div className={classes.time}>
        {handover.atSchool ? props.schoolName : tn.formatTime(new Date(handover.time))}
      </div>
      {handover.atSchool ? null :
        <div className={classes.place}>
          <LocationIcon className={classes.placeIcon}/>
          <span>{handover.location ? handover.location : tn.lang.calDayVisitNoLocation}</span>
        </div>}
    </div>);

  const renderCard = (from:IHandoverData, to:IHandoverData, old:boolean):JSX.Element => (
    <div className={classes.card+(old?" "+classes.cardOld:"")}>
      <div className={classes.day}>{tn.lang.calDayVisitDay(new Date(from.time))}</div>
      <div className={classes.times}>
        {renderHandover(from, classes.startColumn)}
        <div className={classes.dash}>–</div>
        {renderHandover(to, classes.endColumn)}
      </div>
    </div>);

  const changed = props.oldFrom !== undefined && props.oldTo !== undefined;
  const title = props.removed ? tn.lang.calDayVisitRemoved
    : changed ? tn.lang.calDayVisitChanged : tn.lang.calDayVisitAdded;

  return (
    <div className={props.boxClassName}>
      <div className={classes.caption}>{title}</div>
      <div className={classes.parent}>{props.parent}</div>
      {changed && !props.removed ? <>
        {renderCard(props.oldFrom!, props.oldTo!, true)}
        <div className={classes.changeTo}>{tn.lang.calHandoverChangeTo}</div>
      </> : null}
      {renderCard(props.from, props.to, props.removed === true)}
    </div>);
}

export default withStyles(DayVisitChangeStyle)(DayVisitChange);



// WEBPACK FOOTER //
// ./src/components/calendar2/DayVisitChange.tsx